const QUERY_MAPPING = {
  search: {
    code: 'q',
    codeOrigin: 'oq',
    param: 'searchQuery',
    paramOrigin: 'originalQuery',
    path: 'search'
  },
  filter: {
    code: 'filter.',
    param: 'filter.'
  },
  sort: {
    code: 'sort_by',
    param: 'sort_by'
  },
  page: {
    code: 'page',
    param: 'page'
  },
  price: {
    code: 'v.price',
    param: 'v.price',
    high: 'lte',
    low: 'gte'
  },
  separate: {
    code: '.'
  },
  handle: {
    code: 'handle'
  },
  seo: {
    code: 'p.m.seo.hidden'
  }
}

const FILTER_SELECTORS = {
  type: {
    image: 'image',
    colors: 'colors',
    range: 'price_range'
  },
  element: {
    collection: 'plp-native'
  }
}

const handlePriceRange = (key, value, selectedObject) => {
  const { filter, price, separate } = QUERY_MAPPING
  const priceKey = `${filter.code}${price.code}`
  const val = parseInt(value, 10)

  const next = { ...selectedObject }

  if (key.includes(`${price.code}${separate.code}${price.low}`)) {
    next[priceKey] = [val]
  } else if (key.includes(`${price.code}${separate.code}${price.high}`)) {
    if (!Array.isArray(next[priceKey])) next[priceKey] = [0]
    next[priceKey] = [...next[priceKey], val]
  }

  return next
}

const handleFilter = (key, value, selectedObject, filters) => {
  const next = { ...selectedObject }

  if (!Array.isArray(filters)) {
    return next
  }

  const filter = filters.find((item) => item.field === key)
  const filterValue = filter?.values?.find((item) => item.label === value)

  const itemValue = {
    label: value,
    value: filterValue?.value ?? value
  }

  next[key] = [...(next[key] ?? []), itemValue]

  return next
}

const groupParamsByKey = (params, filters = []) => {
  if (!params || !(params instanceof URLSearchParams)) {
    throw new Error('Invalid params: Expected URLSearchParams instance')
  }

  const selectedObject = {}
  const result = {
    selectedValues: selectedObject
  }

  params.forEach((value, key) => {
    if (!value) return

    if (key === QUERY_MAPPING.search.code) {
      result[QUERY_MAPPING.search.param] = value

      return
    }

    if (key.includes(QUERY_MAPPING.filter.code)) {
      const isPriceFilter = key.includes(QUERY_MAPPING.price.code)
      const updated = isPriceFilter
        ? handlePriceRange(key, value, result.selectedValues)
        : handleFilter(key, value, result.selectedValues, filters)

      result.selectedValues = updated

      return
    }

    if (key.includes(QUERY_MAPPING.sort.code)) {
      const sortKey = key.split(QUERY_MAPPING.separate.code)[0]

      result[sortKey] = { direction: value }

      return
    }

    if (key.includes(QUERY_MAPPING.page.code)) {
      result[key] = parseInt(value, 10)
    }
  })

  return result
}

export { QUERY_MAPPING, FILTER_SELECTORS, groupParamsByKey }
